import React, { forwardRef } from "react";
import styled from "styled-components";
import { EllipsisVertical } from "lucide-react";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { getNewLookTokens, NEW_LOOK_RADIUS } from "common/NewLook/tokens.ts";

/** New look: a quiet "more actions" button for table rows. */
const RowActionsTrigger = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  return (
    <Trigger
      ref={ref}
      type="button"
      aria-label={t("labels.actions")}
      {...props}
    >
      <EllipsisVertical size={16} strokeWidth={1.75} />
    </Trigger>
  );
});

export default RowActionsTrigger;

const Trigger = styled.button`
  flex: none;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${NEW_LOOK_RADIUS.control}px;
  background: transparent;
  color: ${(p) => getNewLookTokens(p.theme).secondary};
  cursor: pointer;
  transition: background-color 120ms, color 120ms;
  &:hover,
  &.ant-dropdown-open {
    background: ${(p) => getNewLookTokens(p.theme).well};
    box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
    color: ${(p) => getNewLookTokens(p.theme).ink};
  }
  &:focus-visible {
    outline: 2px solid ${(p) => getNewLookTokens(p.theme).focus};
    outline-offset: 1px;
  }
`;
